
import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { Urls } from '@/apiConnection/urls';
import { ClientFormComponent } from '../client-form/client-form.component';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './client-list.page.html',
  styleUrl: './client-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class ClientListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  public url = Urls.urls.clients;

  public headers = [
    { name: 'Número', key: 'id_by_company' },
    { name: 'NOMBRE', key: 'name' },
    { name: 'CIF/NIF', key: 'nif' },
    { name: "Teléfono", key: 'phone_1' },
    { name: "Email", key: 'email_1' },
    { name: "Ciudad", key: 'city' },
  ];

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(ClientFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'cliente';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
